var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g({class:_vm.clsx('ui-button', ( _obj = {
    'ui-button--loading': _vm.isLoading,
    'ui-button--disabled': _vm.isDisabled || _vm.isLoading
  }, _obj[("ui-button--size-" + _vm.size)] = true, _obj )),attrs:{"disabled":_vm.isDisabled || _vm.isLoading}},_vm.$listeners),[(!_vm.isLoading)?_c('span',{staticClass:"ui-button__content"},[_vm._t("default")],2):_vm._e(),(_vm.isLoading)?_c('span',{staticClass:"ui-button__loader"},[_c('SpinnerLoader')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }